module.exports = (__webpack_require__(0))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./src/rest.js from dll-reference girder_plugin_large_image
// module id = 3
// module chunks = 0